import { OreInput, OreMessageBar, OreStack, OreText } from '@edenredespana/oreneta'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { ResetPasswordData } from '@/Account/ui/hooks'
import { handleErrors } from '@/Shared/ui/form'
import { formTranslation } from '@/Shared/ui/sharedTranslation'
import { LoginTranslation } from '../accountTranslation'

interface PasswordResetBasicFormProps {
  token: string;
}

export const PasswordResetBasicForm = ({ token }: PasswordResetBasicFormProps): JSX.Element => {
  const { t } = useTranslation()
  const { register, formState } =
    useFormContext<ResetPasswordData>()
  const { errors } = handleErrors(formState)

  return (
    <OreStack direction="column" space="small" placeContent="stretch">
      <OreInput
        {...register('password')}
        {...errors('password')}
        type="password"
        id="password"
        label={t(LoginTranslation.recovery.form.passwordLabel)}
        legend={t(LoginTranslation.recovery.form.passwordLegend)}
        required
        maxLength={75}
      />
      <OreInput
        {...register('passwordRepeat')}
        {...errors('passwordRepeat')}
        type="password"
        id="repeatPassword"
        label={t(LoginTranslation.recovery.form.repeatPasswordLabel)}
        required
        maxLength={75}
      />
      <input type="hidden" {...register('token')} value={token} />
      <OreText tone="neutral">
        {t(formTranslation.common.requiredFields)}
      </OreText>
      
      {formState.errors.root && (
        <OreMessageBar>
          {formState.errors.root.message}
        </OreMessageBar>
      )}

    </OreStack>
  )
}
